export default __webpack_public_path__ + "static/media/aiSecurityRealcase-mobile.a0794518.jpg";